import { ParkEventsPage } from "./ParkEventsPage";
import { EVENT_TYPE } from "./types/EVENT_TYPE";

export const IndependentEventPage = (props: { pageTitle: string }) => {
  return <ParkEventsPage pageTitle={props.pageTitle} eventType={EVENT_TYPE.Independent} />;
};
